import { ActiveTrial, ThicknessBottle, TrialType } from "../types";
import {
  isDateLikeSearchTerm,
  matchesDateFilter,
  matchesDateSearch
} from "./dateTime";

export type ThicknessFilters = {
  date: string | null;
  trials: Record<TrialType, string[]>;
};

export const defaultThicknessFilters: ThicknessFilters = {
  date: null,
  trials: {
    Glaschemie: [],
    Brennstoff: [],
    "Energieverhältnis": [],
    Formgebung: []
  }
};

export function applyThicknessFilters(
  data: ThicknessBottle[],
  filters: ThicknessFilters,
  searchTerm: string
): ThicknessBottle[] {
  const search = searchTerm.trim();
  const loweredSearch = search.toLowerCase();
  const searchIsDateLike = isDateLikeSearchTerm(search);
  return data.filter((row) => {
    if (search) {
      if (searchIsDateLike) {
        if (!matchesDateSearch(row.timestamp, search)) return false;
      } else {
        const haystack = `${row.trial_name || ""} ${row.relative_bottle_id || ""}`.toLowerCase();
        if (!haystack.includes(loweredSearch)) return false;
      }
    }
    if (filters.date) {
      if (!matchesDateFilter(row.timestamp, filters.date)) {
        return false;
      }
    }
    if (!matchesTrialFilters(row.active_trials || [], filters.trials)) {
      return false;
    }
    return true;
  });
}

function matchesTrialFilters(activeTrials: ActiveTrial[], selections: Record<TrialType, string[]>) {
  const selectionEntries = Object.entries(selections) as [TrialType, string[]][];
  for (const [trialType, selectedNames] of selectionEntries) {
    if (!selectedNames.length) continue;
    const matchesGroup = activeTrials.some(
      (trial) =>
        trial.trial_type.toLowerCase() === trialType.toLowerCase() &&
        selectedNames.includes(trial.descriptive_name)
    );
    if (!matchesGroup) return false;
  }
  return true;
}
